import { CompanyReportSectionConfig, IntermediaryNumber, ReportDate, Scope } from ".";

export class GlobalReportConfig {
    private _salesOverviewSectionConfigList: CompanyReportSectionConfig[];
    private _salesAndActivitySectionConfigList: CompanyReportSectionConfig[];
    private _customersSectionConfigList: CompanyReportSectionConfig[];
    private _otherParametersSectionConfigList: CompanyReportSectionConfig[];
    private _reportDateList: ReportDate[];
    private _intermediaryList: IntermediaryNumber[];
    private _scopeList: Scope[] = [];

    constructor(
        salesOverviewSectionConfigList: CompanyReportSectionConfig[],
        salesAndActivitySectionConfigList: CompanyReportSectionConfig[],
        customersSectionConfigList: CompanyReportSectionConfig[],
        otherParametersSectionConfigList: CompanyReportSectionConfig[],
        reportDateList: ReportDate[],
        intermediaryList: IntermediaryNumber[],
        scopeList: Scope[]
    ) {
        this._salesOverviewSectionConfigList = salesOverviewSectionConfigList;
        this._salesAndActivitySectionConfigList = salesAndActivitySectionConfigList;
        this._customersSectionConfigList = customersSectionConfigList;
        this._otherParametersSectionConfigList = otherParametersSectionConfigList;
        this._reportDateList = reportDateList;
        this._intermediaryList = intermediaryList;
        this._scopeList = scopeList;
    }

    get salesOverviewSectionConfigList() {
        return this._salesOverviewSectionConfigList;
    }

    get salesAndActivitySectionConfigList() {
        return this._salesAndActivitySectionConfigList;
    }

    get customersSectionConfigList() {
        return this._customersSectionConfigList;
    }

    get otherParametersSectionConfigList() {
        return this._otherParametersSectionConfigList;
    }

    get reportDateList() {
        return this._reportDateList;
    }

    get intermediaryList() {
        return this._intermediaryList;
    }

    get scopeList() {
        return this._scopeList;
    }
}
